"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_NOT_FOUND = void 0;
const notFound_1 = __importDefault(require("../../notFound"));
const route_1 = require("./route");
exports.PROJECT_NOT_FOUND = route_1.PROJECT.sub("/*", notFound_1.default);
